<template>
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="18.5859"
      cy="18.5894"
      r="17.5"
      :fill="reversed ? dark : light"
      :stroke="dark"
      stroke-width="2.17893"
    />
    <path
      d="M11.5859 18.5894L24.7109 18.5894"
      :stroke="reversed ? light : dark"
      stroke-width="1.53809"
      stroke-linecap="round"
    />
    <path
      d="M18.5859 12.4644L25.5859 18.5894L18.5859 24.7144"
      :stroke="reversed ? light : dark"
      stroke-width="1.53809"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCardArrow',
  props: {
    reversed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dark: '#312849',
      light: '#D9D2FF'
    }
  }
}
</script>
